import { datadogRum } from '@datadog/browser-rum';
export { datadogRum } from '@datadog/browser-rum';

const datadogDefaultConfig = {
    allowedTracingUrls: [
        {
            match: /https:\/\/.*(picsart|picsartstage2)\.com/,
            propagatorTypes: ["datadog"],
        },
    ],
    applicationId: "58f0406e-12c1-4707-ab17-b2a14287c6ee",
    clientToken: "pub16ef98ea8034539928fe7a4ad90f0345",
    service: process.env.VITE_APP_DD_SERVICE || process.env.REACT_APP_DD_SERVICE,
    env: process.env.VITE_APP_DD_ENV || process.env.REACT_APP_DD_ENV,
    version: process.env.VITE_APP_VERSION,
    defaultPrivacyLevel: "mask-user-input",
    site: "datadoghq.com",
    trackUserInteractions: true,
    sessionSampleRate: 100,
    traceSampleRate: 20,
    sessionReplaySampleRate: 10,
    traceContextInjection: "sampled",
    trackResources: true,
    trackLongTasks: true,
    trackSessionAcrossSubdomains: true,
    usePartitionedCrossSiteSessionCookie: true,
    useSecureSessionCookie: true,
    actionNameAttribute: "data-testid",
    beforeSend: (event) => {
        if (event.type === "resource") {
            if (event.resource.url.includes("analytics.google.com")) {
                return false;
            }
        }
        return true;
    },
};

function setUserContext(callback) {
    const userContextUnsubscribe = callback().general.auth.subscribe((userContext) => {
        if (userContext && Object.keys(userContext).length > 0) {
            datadogRum.setUser(userContext);
        }
    });
    return () => {
        userContextUnsubscribe === null || userContextUnsubscribe === void 0 ? void 0 : userContextUnsubscribe();
    };
}

function botDetection() {
    // regex patterns to identify known bot instances:
    const botPattern = "(googlebot|bot|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|HeadlessChrome|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis|PA-MONITORING)";
    const regex = new RegExp(botPattern, "i");
    return regex.test(navigator.userAgent);
}
function initDataDogRUM(config) {
    const mergedConfig = Object.assign(Object.assign({}, datadogDefaultConfig), config.initParams);
    try {
        if (!mergedConfig.applicationId || !mergedConfig.clientToken) {
            console.warn("⛔ Datadog RUM initialization failed: applicationId and clientToken are required.");
            return;
        }
        const missingFields = ["service", "env", "version"].filter((key) => !mergedConfig[key]);
        if (missingFields.length > 0) {
            console.log(`⛔ Initialization interrupted: Missing fields - ${missingFields.join(", ")}`);
            return;
        }
        for (const key in config.globalContext) {
            datadogRum.setGlobalContextProperty(key, config.globalContext[key]);
        }
        if (!botDetection()) {
            datadogRum.init(mergedConfig);
        }
        if (config.userContext && Object.keys(config.userContext).length > 0) {
            datadogRum.setUser(config.userContext);
        }
        else {
            if (config.getContext) {
                setUserContext(config.getContext);
            }
        }
    }
    catch (error) {
        console.error("Cannot init Datadog", error);
    }
}

export { initDataDogRUM };
